var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.media)?_c('div',{staticClass:"video"},[_c('iframe',{attrs:{"type":"text/html","width":"640","height":"360","frameborder":"0","data-id":_vm.media.id,"data-type":_vm.media.type,"src":_vm.media.embedurl}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }